module.exports = __webpack_public_path__ + "static/media/chart-growth.56c64185.svg";